import * as React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

export const overlayStyle = (loaded: boolean): {} => {
  if (!loaded) {
    return {
      left: 0,
      background: 'black',
      zIndex: 100,
      display: 'block',
      opacity: 0.5,
      position: 'relative'
    };
  } else {
    return null;
  }
};

export const renderOverlayLoading = (loaded: boolean, topPosition: string): JSX.Element => {
  if (!loaded) {
    return(
      <div style={{zIndex: 110, position: 'absolute', left: '45%', top: topPosition}} >
        <CircularProgress size={200} thickness={15} />
      </div>
    );
  } else {
    return(null);
  }
};



// WEBPACK FOOTER //
// ./src/util/Overlay.tsx